
const routes = [

  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/login.vue')
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/ForgotPassword.vue')
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "empresa" */ '@/components/Auth/ResetPassword.vue')
  },
];

export default routes.map(route => {
  return { ...route, meta: { public: true, onlyLoggedOut: true } }
})